import DatePicker from '../molecules/DatePicker';
import TextInput from '../molecules/TextInput';
import FormikDropdown from './form/FormikDropdown';

type BaseProps = {
  label: string;
  required?: boolean;
};

type TextInputProps = {
  type: 'Text';
  value: string;
  onChange: (value: string) => void;
};

type DatePickerProps = {
  type: 'DatePicker';
  value: Date;
  onChange: (value: Date) => void;
};

type SelectProps = {
  type: 'Select';
  value: string;
  onChange: (value: string) => void;
  options: string[];
};

type ToggleProps = {
  type: 'Toggle';
  value: boolean;
  onChange: (value: boolean) => void;
};

type Props = BaseProps & (TextInputProps | DatePickerProps | SelectProps | ToggleProps);

const ReturnFormInput = (props: Props) => {
  const { type, label, required, onChange, value } = props;

  if (type === 'Select') {
    const { options } = props;

    return (
      <FormikDropdown
        name={label}
        error={undefined}
        options={options.map((option) => ({
          value: option,
          label: option,
        }))}
        translateKey={label}
        onChange={(option: any) => {
          onChange(option.value);
        }}
        value={value}
        className={undefined}
        noTranslation
      />
    );
  }

  if (type === 'Text') {
    return (
      <TextInput
        onChange={(e) => {
          const newValue = e.target ? (e.target as HTMLInputElement).value : e;
          onChange(newValue as string);
        }}
        required={required}
        value={value}
        title={label}
        noTranslation
      />
    );
  }

  if (type === 'DatePicker') {
    return (
      <>
        <p style={{ marginBottom: '12px' }}>{label}</p>
        <DatePicker
          required={required}
          onChange={onChange}
          dropdownLayout
          value={value}
        />
      </>
    );
  }

  if (type === 'Toggle') {
    return null; // Toggle component not implemented yet
  }

  return null;
};

export default ReturnFormInput;
